// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--21f8b","text":"styles-module--text--4b712"};